module.exports = __webpack_public_path__ + "img/logo_ucat3.1b8c8bcc.png";